import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

import LawsInside from "./LawsInside.js";

const content = (
     <span>
          (مصوب ۷/۲/۱۳۱۶)
          <br/>
          معاملات بيمه
          <br />
          ماده ۱- بيمه عقدي است كه به موجب آن يك طرف تعهد مي كند در ازاء پرداخت وجه يا وجوهي از طرف ديگر در صورت وقوع يا بروز حادثه خسارت وارده بر او را جبران نموده يا وجه معيني بپردازد.
          <br />
          متعهد را بيمه گر طرف تعهد را بيمه گذار وجهي را كه بيمه گذار به بيمه گر مي پردازد حق بيمه و آنچه را كه بيمه مي شود موضوع بيمه نامند
          <br />
          ماده ۲- عقد بيمه و شرايط آن بايد به موجب سند كتبي باشد و سند مزبور موسوم به بيمه نامه خواهد بود.
          <br />
          ماده ۳- در بيمه نامه بايد امور ذيل بطور صريح قيد شود.
          <br />
          ۱- تاريخ انعقاد قرارداد .
          <br />
          ۲- اسم بيمه گر و بيمه گذار .
          <br />
          ۳- موضوع بيمه .
          <br />
          ۴- حادثه يا خطري كه عقد بيمه به مناسبت آن بعمل آمده است.
          <br />
          ۵- ابتدا و انتهاي بيمه .
          <br />
          ۶- حق بيمه
          <br />
          ۷- ميزان تعهد بيمه گر درصورت وقوع حادثه
          <br />
          ماده ۴- موضوع بيمه ممكن است مال باشد اعم از عين يا منفعت يا هر حق مالي يا هر نوع مسئوليت حقوقي مشروط بر اينكه بيمه گذار نسبت به بقاء آنچه بيمه مي دهد ذي نفع باشد و همچنين ممكن است بيمه براي حادثه يا خطري باشد كه از وقوع آن بيمه گذار متضرر    مي گردد.
          <br />
          ماده ۵- بيمه گذار ممكن است اصيل باشد يا به يكي از عناوين قانوني نمايندگي صاحب مال يا شخص ذينفع را داشته يا مسئوليت حفظ آن را از طرف صاحب مال داشته باشد.
          <br />
          ماده ۶- هركس بيمه مي دهد بيمه متعلق به خود اوست مگر آنكه در بيمه نامه تصريح شده باشد كه مربوط به ديگري است ليكن در بيمه حمل و نقل ممكن است بيمه نامه بدون ذكر اسم (‌بنام حامل )‌ تنظيم شود.
          <br />
          ماده ۷- طلبكار مي تواند مالي را كه در نزد او وثيقه يا رهن است بيمه دهد دراين صورت هرگاه حادثه اي نسبت به مال مزبور رخ دهد از خساراتي كه بيمه گر بايد بپردازد تا ميزان آنچه را كه بيمه گذار در تاريخ موقوع حادثه طلبكار است به شخص او و بقيه به صاحب مال تعلق خواهد گرفت.
          <br />
          ماده ۸- در صورتي كه مالي بيمه شده باشد در مدتي كه بيمه باقيست نمي توان همان مال را به نفع همان شخص و از همان خطر مجددا بيمه نمود.
          <br />
          ماده ۹- در صورتي كه مالي به كمتر از قيمت بيمه شده باشد نسبت به بقيه قيمت مي توان آن را بيمه نمود دراين صورت هريك از بيمه گران به نسبت مبلغي از مال كه بيمه كرده است مسئول خواهد بود.
          <br />
          ماده ۱۰- درصورتي كه مالي به كمتر از قيمت واقعي بيمه شده باشد بيمه گر فقط به تناسب مبلغي كه بيمه كرده است با قيمت واقعي مال مسوول خسارت خواهد بود.
          <br />
          فسخ و بطلان
          <br />
          ماده ۱۱- چنانچه بيمه گذار يا نماينده او با قصد تقلب مالي را اضافه برقيمت عادله در موقع عقد قرارداد بيمه داده باشد عقد بيمه باطل و حق بيمه دريافتي قابل استرداد نيست .
          <br />
          ماده ۱۲- هرگاه بيمه گذار عمدا از اظهار مطالبي خودداري كند يا عمدا اظهارات كاذبه بنمايد و مطالب اظهار نشده يا اظهارات كاذبه طوري باشد كه موضوع خطر را تغيير داده يا از اهميت آن در نظر بيمه گر بكاهد عقد بيمه باطل خواهد بود حتي اگر مراتب مذكوره تاثيري در وقوع حادثه نداشته باشد. دراين صورت نه فقط وجوهي كه بيمه گذار پرداخته است قابل استرداد نيست بلكه بيمه گر حق دارد اقساط بيمه را كه تا آن تاريخ عقب افتاده است نيز از بيمه گذار مطالبه كند.
          <br />
          ماده ۱۳- اگر خودداري از اظهار مطالبي يا اظهارات خلاف واقع از روي عمد نباشد عقد بيمه باطل نمي شود – دراين صورت هرگاه مطالب اظهار نشده يا اظهار خلاف واقع قبل از وقوع حادثه معلوم شود بيمه گر حق دارد يا اضافه حق بيمه را از بيمه گذار درصورت رضايت او دريافت داشته قرارداد را ابقاء‌ كند و يا قرارداد بيمه را فسخ كند – درصورت فسخ بيمه گر بايد مراتب را به موجب اظهار نامه يا نامه سفارشي دو قبضه به بيمه گذاراطلاع دهد اثر فسخ ده روز پس از ابلاغ مراتب به بيمه گذار شروع مي شود و بيمه گر بايد اضافه حق بيمه دريافتي تا تاريخ فسخ را به بيمه گذار مسترد دارد.
          <br />
          درصورتي كه مطالب اظهار نشده يا اظهار خلاف واقع بعد از وقوع حادثه معلوم شود خسارت به نسبت وجه بيمه پرداختي و وجهي كه بايستي درصورت اظهار خطر بطور كامل و واقع پرداخته شده باشد تقليل خواهد يافت.
          <br />
          ماده ۱۴- بيمه گر مسوول خسارات ناشيه از تقصير بيمه گذار يا نمايندگان او نخواهد بود.
          <br />
          ماده ۱۵- بيمه گذار بايد براي جلوگيري از خسارت مراقبتي را كه عادتا هركس از مال خود مي نمايد نسبت به موضوع بيمه نيز بنمايد و در صورت نزديك شدن حادثه يا وقوع آن اقداماتي را كه براي جلوگيري از سرايت و توسعه خسارت لازم است بعمل آورد . اولين زمان امكان و منتهي در ظرف پنج روز از تاريخ اطلاع خود از وقوع حادثه بيمه گر را مطلع سازد والا بيمه گر مسئول نخواهد بود مگر آنكه بيمه گذار ثابت كند كه بواسطه حوادثي كه خارج از اختيار او بوده است اطلاع به بيمه گر در مدت مقرر براي او مقدور نبوده است .
          <br />
          مخارجي كه بيمه گذار براي جلوگيري از توسعه خسارت مي نمايد بر فرض كه منتج به نتيجه نشود بعهده بيمه گر خواهد بود ولي هر گاه بين طرفين در موضوع لزوم مخارج مزبوره يا تناسب آن با موضوع بيمه اختلافي ايجاد شود حل اختلاف به حكم يا محكمه رجوع مي شود.
          <br />
          ماده ۱۶- هرگاه بيمه گذار در نتيجه عمل خود خطري را كه به مناسبت آن بيمه منعقد شده است تشديد كند يا يكي از كيفيات آن بيمه منعقد شده است تشديد كند يا يكي از كيفيات يا وضعيت موضوع بيمه را بطوري تغيير دهد كه اگر وضعيت مزبور قبل از قرارداد موجود بود بيمه گر حاضر براي انعقاد قرارداد با شرايط مذكوره در قرارداد نمي گشت بايد بيمه گر را بلافاصله از آن مستحضر كند – اگر تشديد خطر يا تغيير وضعيت موضوع بيمه در نتيجه عمل بيمه گذار نباشد مشاراليه بايد مراتب را در ظرف ده روز از تاريخ اطلاع خود رسما به بيمه گر اعلام كند .
          <br />
          در هر دو مورد مذكور در فوق بيمه گر حق دارد اضافه حق بيمه را معين نموده به بيمه گذار پيشنهاد كند و در صورتي كه بيمه گذار حاضر براي قبولي و پرداخت آن نشود قرارداد را فسخ كند و اگر تشديد خطر در نتيجه عمل خود بيمه گذار باشدخسارات وارده را نيز از مجراي محاكم عمومي از او مطالبه كند و درصورتي كه بيمه گر پس از اطلاع تشديد خطر به نحوي از انحاء رضايت به بقاء عقد قراداد داده باشد مثل آنكه اقساطي از وجه بيمه را پس از اطلاع از مراتب از بيمه گذار قبول كرده يا خسارت بعد از وقوع حادثه به او پرداخته باشد ديگر نمي تواند به مراتب مذكوره استناد كند – وصول اقساط حق بيمه بعد از اطلاع از تشديد خطر يا پرداخت خسارت پس از وقوع حادثه و نحو آن دليل بر رضايت بيمه گر به بقاء‌ قرارداد مي باشد.
          <br />
          ماده ۱۷- درصورت فوت بيمه گذار يا انتقال موضوع بيمه به ديگري اگر ورثه يا منتقل اليه كليه تعهداتي را كه موجب قرارداد بعهده بيمه گذار بوده است در مقابل بيمه گر اجرا كند عقد بيمه به نفع ورثه يا منتقل اليه به اعتبار خود باقي مي ماند معهذا هريك از بيمه گر يا ورثه يا منتقل اليه حق فسخ آن را نيز خواهند داشت.
          <br />
          بيمه گر حق دارد در ظرف سه ماه از تاريخي كه منتقل اليه قطعي موضوع بيمه تقاضاي تبديل بيمه نامه را به نام خود مي نمايد عقد بيمه را فسخ كند.
          <br />
          درصورت انتقال موضوع بيمه به ديگري ناقل مسئول كليه اقساط عقب افتاده وجه بيمه در مقابل بيمه گر خواهد بود ليكن از تاريخي كه انتقال را به بيمه گر بموجب نامه سفارشي يا اظهار نامه اطلاع مي دهد نسبت به اقساطي كه از تاريخ اطلاع به بعد بايد پرداخته شود مسئول نخواهد بود.
          <br />
          اگر ورثه يا منتقل اليه متعدد باشند هريك از آنها نسبت به تمام وجه بيمه در مقابل بيمه گر مسئول خواهد بود.
          <br />
          ماده ۱۸- هرگاه معلوم شود خطري كه براي آن بيمه به عمل آمده قبل از عقد قرارداد واقع شده بوده است قرارداد بيمه باطل و بي اثر خواهد بود دراين صورت اگر بيمه گر وجهي از بيمه گذار گرفته باشد عشر از مبلغ مزبور را بعنوان مخارج كسر و بقيه را بايد به بيمه گذار مسترد دارد.
          <br />
          مسوليت بيمه گر
          <br />
          ماده ۱۹- مسووليت بيمه گر عبارت است از تفاوت قيمت مال بيمه شده بلافاصله قبل ازوقوع حادثه با قيمت باقي مانده آن بلافاصله بعد از حادثه خسارت حاصله به پول نقد پرداخته خواهد شد مگر اينكه حق تعمير و يا عوض براي بيمه گر در سند بيمه پيش بيني شده باشد دراين صورت بيمه گر ملزم است موضوع بيمه را در مدتي كه عرفا كمتر از آن نمي شود تعمير كرده يا عوض را تهيه و تحويل نمايد.
          <br />
          در هر صورت حداكثر مسئوليت بيمه گر از مبلغ بيمه شده تجاوز نخواهد كرد.
          <br />
          ماده ۲۰- بيمه گر مسئول خساراتي كه عيب ذاتي مال ايجاد مي شود نيست مگر آنكه در بيمه نامه شرط خلافي شده باشد.
          <br />
          ماده ۲۱- خسارات وارده از حريق كه بيمه گر مسئول آن است عبارت است از :‌
          <br />
          ۱- خسارت وارده به موضوع بيمه از حريق اگر چه حريق در نزديكي آن واقع شده باشد.
          <br />
          ۲- هرخسارت يا تنزل قيمت وارده به اموال از آب يا هر وسيله ديگري كه براي خاموش كردن آتش بكار برده شده است.
          <br />
          ۳- تلف شدن يا معيوب شدن مال در موقع نجات دادن آن از حريق .
          <br />
          ۴- خسارت وارده به اموال بيمه شده در نتيجه خراب كردن كلي يا جزئي بناء براي جلوگيري از سرايت يا توسعه حريق.
          <br />
          ماده ۲۲- در بيمه هاي ذيل خسارت به اين طريق حساب مي شود:‌
          <br />
          ۱- در بيمه حمل و نقل قيمت مال در مقصد.
          <br />
          ۲- دربيمه منافعي كه متوقف بر امري است منافعي كه در صورت پيشرفت امر عايد بيمه گذار مي شد.
          <br />
          ۳- در بيمه محصول زراعتي قيمت آن در سر خرمن و موقع برداشت محصول . براي تعيين ميزان واقعي خسارت مخارج و حق الزحمه كه درصورت عدم وقوع حادثه به مال تعلق مي گرفت از اصل قيمت كسر خواهد شد و در هر صورت ميزان خسارت از قيمت معينه در بيمه نامه تجاوز نخواهد كرد.
          <br />
          ماده ۲۳- در بيمه عمر يا نقص يا شكستن عضوي از اعضاء بدن مبلغ پرداختي بعد از مرگ يا نقصان عضو بايد بطور قطع در موقع عقد بيمه بين طرفين معين شود.
          <br />
          بيمه عمر يا بيمه نقصان يا شكستن عضو شخص ديگري درصورتي كه آن شخص قبلا رضايت خود را كتباٌ نداده باشد باطل است.
          <br />
          هرگاه بيمه گذار اهليت قانوني نداشته باشد رضايت ولي يا قيم او شرط است.
          <br />
          اگر بيمه راجع به عمر يا نقص يا شكستن عضو بدن جماعتي بطور كلي باشد ميزان خسارت عبارت از مبلغي خواهد بود كه مطابق تعرفه قبلا بين طرفين معين مي شود.
          <br />
          ماده ۲۴- وجه بيمه عمر كه بايد بعد از فوت پرداخته شود به ورثه قانوني متوفي پرداخته مي شود مگر اينكه در موقع عقد بيمه يا بعد از آن در سند بيمه قيد ديگري شده باشد كه دراين صورت وجه بيمه متعلق به كسي خواهد بود كه در سند بيمه اسم برده شده است.
          <br />
          ماده ۲۵- بيمه گذار حق دارد ذي نفع در سند بيمه عمر خود را تغيير دهد مگر انكه آن را به ديگري انتقال داده و بيمه نامه را هم به منتقل اليه تسليم كرده باشد.
          <br />
          ماده ۲۶- در تمام مدت اعتبار قرارداد بيمه عمر بيمه گذار حق دارد وجه معينه در بيمه نامه را به ديگري منتقل نمايد انتقال مزبور بايد به امضاء انتقال دهنده و بيمه گر برسد.
          <br />
          ماده ۲۷- اثرات قانوني انتقال وجه بيمه عمر از تاريخ فوت بيمه شده شروع مي شود ولي اگر بيمه گذار از بابت آن وجهي دريافت كرده يا نسبت به آن با بيمه گر معامله نموده باشد در كمال اعتبار خواهد بود.
          <br />
          ماده ۲۸- بيمه گر مسئول خسارات ناشيه از جنگ و شورش نخواهد بود مگر آنكه خلاف آن در بيمه نامه شرط شده باشد.
          <br />
          ماده ۲۹- درمورد بيمه مال منقول درصورت وقوع حادثه و پرداخت خسارت به بيمه گذار بيمه گر از هرگونه مسئوليت در مقابل ثالث بري مي شود.
          <br />
          ماده ۳۰- بيمه گر در حدودي كه خسارات وارده را قبول يا پرداخت مي كند در مقابل اشخاصي كه مسئول وقوع حادثه يا خسارت هستند قائم مقام بيمه گذار خواهد بود و اگر بيمه گذار اقدامي كند كه منافي با عقد مزبور باشد در مقابل بيمه گر مسئول شناخته مي شود.
          <br />
          ماده ۳۱- درصورت توقف يا افلاس بيمه گر بيمه گذار حق فسخ قرارداد را خواهد داشت.
          <br />
          ماده ۳۲- درصورت ورشكستگي بيمه گر بيمه گذاران نسبت به ساير طلبكاران حق تقدم دارند و بين معاملات مختلف بيمه در درجه اول حق تقدم با معاملات بيمه عمر است.
          <br />
          ماده ۳۳- بيمه گر نسبت به حق بيمه در مقابل هرگونه طلبكاري بر مال بيمه شده حق تقدم دارد حتي اگر طلب سايرين به موجب سند رسمي باشد.
          <br />
          ماده ۳۴- اگر دريك قرارداد بيمه موضوعات مختلفه بيمه شده باشد درصورت اثبات تقلب از طرف بيمه گذار نسبت به يكي از آن موضوعات بطلان نسبت به ساير موضوعات نيز سرايت كرده تمام قرارداد باطل خواهد بود.
          <br />
          موضوعات مختلفه كه دريك بيمه نامه ذكر مي شود در حكم يك قرارداد محسوب است.
          <br />
          ماده ۳۵- طرفين مي توانند در قراردادهاي بيمه هر شرط ديگري بنمايند ليكن موعد مذكوره در ماده ۱۶ را نمي توانند تقليل دهند ولي ممكن است موعد را به رضايت يكديگر تمديد كنند.
          <br />
          اين قانون شامل قراردادهاي گذشته بيمه نيز خواهد بود.
          <br />
          ماده ۳۶- مرور زمان دعاوي ناشي از بيمه دو سال است و ابتداي آن از تاريخ وقوع حادثه منشاء دعوي خواهد بود لكن دعاوي كه قبل از اجراي اين قانون در محاكم طرح شده باشد مشمول اين ماده نخواهد بود.
          <br />
          اين قانون كه مشتمل بر سي و شش ماده است در جلسه هفتم ارديبهشت ماه يكهزارو سيصدو و شانزده به تصويب مجلس شوراي ملي رسيد.
     </span>
);
const SpecificOneInside = props => {
     return props.size === "laptopdesktop" ? (
          <div>
               <LawsInside title="قانون بیمه" text={content} size="laptopdesktop" />
          </div>
     ) : props.size === "tablet" ? (
          <div>
               <LawsInside title="قانون بیمه" text={content} size="tablet" />
          </div>

     ) : (
          <div>
               <LawsInside title="قانون بیمه" text={content} />
          </div>
     );
};

export default SpecificOneInside;
